<template>
    <b-container fluid>
        <app-supervision-activity-header
            >Recomendación de Seguridad</app-supervision-activity-header
        >
        <app-safety-recommendation-form
            ref="safetyRecommendationForm"
            :access-points="accessPoints"
            :on-save="onSave"
            :localization="true"
        ></app-safety-recommendation-form>
        <b-row class="justify-content-end">
            <b-col cols="12" md="4" lg="3">
                <b-btn
                    block
                    @click="saveRecommendation"
                    :disabled="inProgress"
                    variant="confirm"
                    ><i class="fa fa-save"></i> Guardar</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import SupervisionActivityHeader from '../SupervisionActivityHeader'
import SafetyRecommendationForm from '../../Vigilance/SafetyRecommendations/SafetyRecommendationForm/SafetyRecommendationForm.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        appSupervisionActivityHeader: SupervisionActivityHeader,
        appSafetyRecommendationForm: SafetyRecommendationForm,
    },
    data: () => ({
        accessPoints: [],
    }),
    computed: {
        ...mapGetters(['supervisionClient']),
        // accessPoints() {
        //     return this.supervisionClient.structures.filter(
        //         item => !!item.structure_type.access_point
        //     );
        // }
    },
    methods: {
        async loadAccessPoints() {
            const { data } = await repo.get(
                `structures/access-points/client/${this.supervisionClient.id}`
            )
            this.accessPoints = data
        },
        saveRecommendation() {
            this.$refs.safetyRecommendationForm.saveOrUpdate()
        },
        onSave() {
            this.$refs.safetyRecommendationForm.cleanForm()
            this.$router.push({ name: 'supervisionIndexPage' })
        },
    },
    created() {
        this.loadAccessPoints()
    },
}
</script>
